import { __makeTemplateObject } from "tslib";
import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
export var useFilesUploadedStyles = makeStyles(function () { return ({
    fileUploaded: {
        height: "50px",
        width: "auto",
        padding: "9px 13px 9px 10px",
        margin: "8px",
        borderRadius: "4px",
        border: function (props) { return "solid 1px ".concat(props["borderColor"]); },
        cursor: function (props) { return "".concat(props["isDownload"] ? "pointer" : "auto"); },
        "&>.container": {
            display: "flex",
            marginTop: "-2px",
            justifyContent: "center"
        }
    },
    spacer: {
        height: "1px",
        margin: "16px 0",
        border: "solid 1px hsl(224,14%,15%)"
    },
    subContainer: {
        width: "100%",
        paddingRight: "10px",
        marginTop: "-2px"
    },
    icon: {
        cursor: "pointer"
    }
}); });
export var MediaUploadHeading = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-bottom: 10px;\n\topacity: 0.38;\n\tfont-size: 12px;\n\tfont-weight: bold;\n\tline-height: 1.33;\n\tletter-spacing: normal;\n\tcolor: ", ";\n"], ["\n\tmargin-bottom: 10px;\n\topacity: 0.38;\n\tfont-size: 12px;\n\tfont-weight: bold;\n\tline-height: 1.33;\n\tletter-spacing: normal;\n\tcolor: ", ";\n"])), function (props) { return props.theme.palette.text.primary; });
export var FileUploadedText = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-top: 2px;\n\tmargin-bottom: 0;\n\topacity: 0.87;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tline-height: 1.33;\n\tletter-spacing: normal;\n\tcolor: ", ";\n\twhite-space: nowrap;\n\tmax-width: 180px;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"], ["\n\tmargin-top: 2px;\n\tmargin-bottom: 0;\n\topacity: 0.87;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tline-height: 1.33;\n\tletter-spacing: normal;\n\tcolor: ", ";\n\twhite-space: nowrap;\n\tmax-width: 180px;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])), function (props) { return props.color || props.theme.palette.text.secondary; });
export var FileUploadedSize = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-size: 10px;\n\tfont-weight: normal;\n\tfont-stretch: normal;\n\tfont-style: normal;\n\tline-height: normal;\n\tletter-spacing: normal;\n\tcolor: hsl(220, 19%, 63%);\n\tmargin-top: 4px;\n"], ["\n\tfont-size: 10px;\n\tfont-weight: normal;\n\tfont-stretch: normal;\n\tfont-style: normal;\n\tline-height: normal;\n\tletter-spacing: normal;\n\tcolor: hsl(220, 19%, 63%);\n\tmargin-top: 4px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map